// src/pages/CustomerProfileForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import BrandName from '../components/BrandName';
import './AuthPages.css';

const CustomerProfileForm = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm]     = useState({ address: '', phone: '', preferences: '' });
  const [saving, setSaving] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;
    setSaving(true);
    await setDoc(doc(db, 'users', user.uid), {
      address:     form.address,
      phone:       form.phone,
      preferences: form.preferences,
    }, { merge: true });
    setSaving(false);
    navigate('/customer-dashboard');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo"><BrandName /></div>
        <h2>Complete Your Profile</h2>
        <p className="auth-sub">A few more details to get you started</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Address</label>
            <input className="form-input" name="address" placeholder="Your address" value={form.address} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input className="form-input" name="phone" placeholder="Your phone number" value={form.phone} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label className="form-label">Service Preferences</label>
            <input className="form-input" name="preferences" placeholder="e.g. Weekend collections only" value={form.preferences} onChange={handleChange} />
          </div>
          <button type="submit" className="btn btn-primary btn-full" disabled={saving}>
            {saving ? 'SAVING...' : 'SAVE PROFILE'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CustomerProfileForm;
